export const GET_ALL_LAB_TEST_TYPE = "GET_ALL_LAB_TEST_TYPE";
export const CREATE_LAB_TEST_TYPE = "CREATE_LAB_TEST_TYPE";
export const UPDATE_LAB_TEST_TYPE = "UPDATE_LAB_TEST_TYPE";
export const DELETE_LAB_TEST_TYPE = "LAB_TEST_TYPE_DELETE";
export const ADD_TO_LAB_TEST_TYPE = "ADD_TO_LAB_TEST_TYPE";
export const ACTIVE_LAB_TEST_TYPE = "ACTIVE_LAB_TEST_TYPE";


export const API = "API";
export const SET_PROJECT = "SET_PROJECT";